module.exports = __webpack_public_path__ + "img/logo.b7c9524f.png";